import { submitSteps } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function ProcessSection() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="How To Tip"
            title="提交一条线索，只需四步"
            description="你不需要准备完整报道，也不需要实名。请先保证自己的安全，再决定提供到什么程度。"
            align="center"
          />

          <ol className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6">
            {submitSteps.map((step, index) => (
              <li key={step.step} className="relative">
                <div className="flex items-center gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-foreground-950 text-background-50">
                    <i className={`${step.icon} text-xl`}></i>
                  </span>
                  <span className="font-mono text-3xl md:text-4xl font-medium text-foreground-200">
                    {step.step}
                  </span>
                </div>
                {index < submitSteps.length - 1 ? (
                  <span className="hidden lg:block absolute top-6 left-[calc(50%+40px)] right-[-24px] border-t border-dashed border-foreground-950/20"></span>
                ) : null}
                <h3 className="mt-6 font-heading text-base md:text-lg font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}